/****************************************************
 * Module Name:  sideIncProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class SideIncProxy {
    static GetAllSideInc = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/sideinc",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleSideInc = (Id, callback) => {
        let params = {
            id: Id,
        };

        restAPICall(
            Constants.MANAGER_URL + "/sideinc",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllSideIncMini = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/sideinc/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static CheckSideIncAvailable = (sideinc, callback) => {
        let params = {
            sideinc: sideinc,
        };

        restAPICall(
            Constants.MANAGER_URL + "/sideinc/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddSideInc = (sideinc, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/sideinc",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(sideinc),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateSideInc = (sideinc, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/sideinc",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(sideinc),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static DeleteSideInc = (sideinc, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/sideinc",
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(sideinc),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
